import React from 'react';
import './Alert.css';

const Alert = ({ 
  children, 
  variant = 'info', 
  dismissible = false,
  onDismiss,
  className = '',
  ...props 
}) => {
  const [show, setShow] = React.useState(true);

  const handleDismiss = () => {
    setShow(false);
    if (onDismiss) onDismiss();
  };

  if (!show) return null;

  return (
    <div 
      className={`alert alert-${variant} ${dismissible ? 'alert-dismissible' : ''} ${className}`}
      role="alert"
      {...props}
    >
      {children}
      {dismissible && (
        <button 
          type="button" 
          className="close" 
          onClick={handleDismiss}
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      )}
    </div>
  );
};

export default Alert;